import React, { useState, useEffect } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, MenuItem, FormControl, InputLabel, Select, TextField
} from '@mui/material';

const EstatusModal = ({ open, onClose, idPedido, estatusActual, onActualizar }) => {
  const [nuevoEstatus, setNuevoEstatus] = useState(estatusActual);
  const [numeroFactura, setNumeroFactura] = useState('');
  const nombreDelUsuario = localStorage.getItem('Nombre');

  useEffect(() => {
    if (open) {
      setNuevoEstatus(estatusActual);
      setNumeroFactura(''); // Limpiar al abrir
    }
  }, [open, estatusActual]);

  const handleActualizar = async () => {
    try {
      const payload = {
        IdPedido: idPedido,
        Estatus: nuevoEstatus,
        NombreCambio: nombreDelUsuario
      };

      // Si está facturado, incluir el número de factura
      if (nuevoEstatus === 'Facturado') {
        payload.NumFactura = numeroFactura;
      }

      const response = await fetch(`https://bibliotecadlago.com/php/actualizar_estatus.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      const data = await response.json();

      if (data.success) {
        onActualizar();
        onClose();
      } else {
        alert(data.message || 'Error al actualizar el estatus');
      }
    } catch (error) {
      alert('Error de conexión con el servidor');
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Cambiar Estatus</DialogTitle>
      <DialogContent dividers>
        <FormControl fullWidth margin="dense">
          <InputLabel id="estatus-label">Estatus</InputLabel>
          <Select
            labelId="estatus-label"
            value={nuevoEstatus}
            label="Estatus"
            onChange={(e) => setNuevoEstatus(e.target.value)}
          >
            <MenuItem value="Solicitado">Solicitado</MenuItem>
            <MenuItem value="En Facturación">En Facturación</MenuItem>
            <MenuItem value="Facturado">Facturado</MenuItem>
            <MenuItem value="Cancelado">Cancelado</MenuItem>
          </Select>
        </FormControl>

        {nuevoEstatus === 'Facturado' && (
          <TextField
            fullWidth
            margin="dense"
            label="Número de Factura"
            value={numeroFactura}
           onChange={(e) => {
              const value = e.target.value;
              const regex = /^[A-Za-z]{0,2}\d{0,5}$/; // Permite hasta 2 letras y hasta 5 números
              if (value === '' || regex.test(value)) {
                setNumeroFactura(value);
              }
            }}
            helperText="Debe comenzar con dos letras y puede tener hasta 5 números"
          />
        )}

      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="error" onClick={onClose}>Cancelar</Button>
        <Button
          variant="contained"
          sx={{ backgroundColor: 'green', '&:hover': { backgroundColor: '#0b7d0b' } }}
          onClick={handleActualizar}
        >
          Actualizar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EstatusModal;
